import React, { PropsWithChildren } from 'react'
import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'

function SpinLoader(props: PropsWithChildren<{ loading: boolean; className?: string }>) {
	const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />

	return (
		<Spin wrapperClassName={props.className} indicator={antIcon} spinning={props.loading}>
			{props.children}
		</Spin>
	)
}

export default SpinLoader
